const STEP_SEPARATOR = "_"

export namespace ONBOARDING_STEP {
    export const INITIAL_STEP = "initial"
    export const SETUP_COMPANY_DESCRIPTION_STEP = INITIAL_STEP + STEP_SEPARATOR + "setup-company-description"
    export const SETUP_PREFERENCES_STEP = INITIAL_STEP + STEP_SEPARATOR + "setup-preferences"
    export const SETUP_TAXES_STEP = INITIAL_STEP + STEP_SEPARATOR + "setup-taxes"
    export const SETUP_DOCUMENT_TEMPLATES_STEP = INITIAL_STEP + STEP_SEPARATOR + "setup-document-templates"
    export const COMPLETE_ONBOARDING_STEP = "complete-onboarding"
    export const ONLINE_PAYMENT_SETUP_STEP = "online-payment-setup"
    export const INTEGRATION_SETUP_STEP = "integration-setup"
    export const VEND_ACTIVATE_WORKFLOWS_STEP = "vend-activate-workflows"
    export const SIGN_UP_SURVEY_STEP = "sign-up-survey"
    export const START_UP_GUIDE_SURVEY_STEP = "start-up-guide-survey"
}

export function getMainStep(step: ONBOARDING_STEP) {
    const splitSteps = step.split(STEP_SEPARATOR)
    if (splitSteps.length > 0) {
        return splitSteps[0]
    }

    return ONBOARDING_STEP.INITIAL_STEP
}

export type ONBOARDING_STEP = typeof ONBOARDING_STEP[keyof typeof ONBOARDING_STEP];


// WEBPACK FOOTER //
// ./src/onboarding/Steps.ts